module.exports = __webpack_public_path__ + "static/img6-3b0e7875db914b27424052fd0fabc6af.jpg";